import React from "react"

const SearchifyWrapper = (props) => <div className="is-searchify">{props.children}</div>

export default SearchifyWrapper
